export const IMAGE_LOADING_MODES = ["blur", "progressive"] as const;
export type ImageLoadingMode = (typeof IMAGE_LOADING_MODES)[number];
export const IMAGE_LOADING_COOKIE = "image-loading";
export const DEFAULT_IMAGE_LOADING_MODE: ImageLoadingMode = "blur";
